import axios from "axios";
import { showAlert, handleRequestError } from "../utils/alert";

export default () => ({
  email: "",
  isLoading: false,

  async submitRequest() {
    if (!this.email) {
      showAlert("O e-mail é obrigatório.", "warning");
      return;
    }

    const turnstileResponseInput = document.querySelector(
      '[name="cf-turnstile-response"]',
    );
    const turnstileToken = turnstileResponseInput
      ? turnstileResponseInput.value
      : null;

    if (!turnstileToken) {
      showAlert("Por favor, resolva o desafio de segurança.", "warning");
      return;
    }

    this.isLoading = true;

    try {
      const response = await axios.post(
        "/api/client/auth/forgot-password",
        {
          email: this.email,
          "cf-turnstile-response": turnstileToken,
        },
        {
          headers: { Accept: "application/json" },
        },
      );

      showAlert(response.data.message, "success");
      this.email = ""; // Clear form
    } catch (error) {
      handleRequestError(error, "Não foi possível processar sua solicitação.");
    } finally {
      this.isLoading = false;
      if (window.turnstile) {
        window.turnstile.reset();
      }
    }
  },
});
